const NavCategoryTitle = (category, lang) => {
  return `<div class="nav-cat-title">${category[lang]}</div>`;
};

export default NavCategoryTitle;
